import {LoggerType} from './logger.util';

export function logDebugEvent(logger: LoggerType, eventName: string, params: any = {}) {
    params.timestamp = `${new Date().getMinutes()}:${new Date().getSeconds()} ${new Date().getMilliseconds()}`;
    logger.debug(eventName, params);
}